import React, { ReactElement } from 'react';

const LineBreak: ReactMemoComponent = React.memo((): ReactElement => {
  return (
    <br />
  );
});

export default LineBreak;
